module.exports = __webpack_public_path__ + "static/media/006.74e5f3e3.jpg";